import {alertService} from "@/services/alert/alert.service";
import {registerService} from "@/services/auth/register/register.service";
import ProgressBar from './progress-bar.component.vue'

export default {
    components: {
        ProgressBar
      },
    data() {
        return {
            data: {
                email: '',
                lang: this.$i18n.locale
            },
            error: {},
            config: {},
            success: false,
            valid: false,
            passwordRule: (v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~-]).{8,}$/.test(v) || this.$t('auth.password-conditions-not-met'),
            check: false,
        }
    },
    async mounted() {
        this.data.email = this.$route.params.email;
    },
    methods: {
        async register$() {
            if (!this.$refs.form.validate()) return
            alertService.loading();
            await registerService.register(this.data).then((response) => {
                this.success = true;
                alert(this.$t('auth.created-sucessfully'));
                this.$router.push({ name: "guest-login" });
                alertService.close();
            }).catch((response) => {
                this.error = response;
                alertService.close();
            });
        },
    }
}
